export default {
    namespaced: true,
    state: {
      templateSelect: "",
    },
    getters: { 
      templateSelect : state => state.templateSelect, 
    },
    mutations: { 
      SET_TEMPLATE(state, value) { 
          state.templateSelect = value.templateSelect;
      }
    },
    actions: {
      setTemplate({commit}, data){ 
          commit("SET_TEMPLATE", data);
      }
    },
  };